import { input, output, TODO } from '@b2b/types/core';
import angular from 'angular';

/**
 * Represents an add-on/inventory type item that can be selected.
 * Based on the structure returned by getRemainingAddOnsForEvent.
 */
export interface AddonTypeItem {
  id: string;
  name: string;
  description?: string;
  price: string | number | null;
  csrDisabled?: boolean;
  salesChannels?: TODO[];
}

export interface AddonTypeSelectorSelectEvent {
  selectedItem: AddonTypeItem;
}

class AddonTypeSelectorController {
  static $inject = ['$element'];

  items = input<AddonTypeItem[]>([]);
  eventId = input<string>('');
  label = input<string>('');
  disabled = input<boolean>(false);
  onSelect = output<AddonTypeSelectorSelectEvent>();

  selectedItem: AddonTypeItem | null = null;

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-addon-type-selector');
  }

  get computedLabel(): string {
    if (this.label) {
      return this.label;
    }

    const count = this.items?.length ?? 0;
    return count > 0 ? `Add Add-On (${count} more)` : 'Add Add-On';
  }

  get uniqueName(): string {
    return `addon-type-selector-${this.eventId}`;
  }

  handleChange(): void {
    if (this.selectedItem && typeof this.selectedItem === 'object') {
      this.onSelect({ $event: { selectedItem: this.selectedItem } });
      this.selectedItem = null; // Reset after selection
    }
  }
}

export const AddonTypeSelectorComponentModule = angular
  .module('acme.common.component.addonTypeSelector', ['acme.common.directive.combobox'])
  .component('acmeAddonTypeSelector', {
    templateUrl: 'common/components/addon-type-selector/addon-type-selector.component.tpl.html',
    controller: AddonTypeSelectorController,
    bindings: {
      items: '<',
      eventId: '<',
      label: '<',
      disabled: '<',
      onSelect: '&',
    },
  }).name;
